import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

@Component({
  selector: 'optimization-section',
  standalone: true,
  imports: [CommonModule, TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <article class="opt-section"
      [class.opt-section--open]="open"
      [class.opt-section--connect]="connector"
      [class.opt-section--no-padding]="noPadding"
      [style.--opt-section-index]="num">
      <button type="button" class="opt-section__head" (click)="toggle()">
        <span class="opt-section__num">
          @if (icon) {
            <span
              class="opt-section__icon"
              [style.-webkit-mask-image]="'url(' + icon + ')'"
              [style.mask-image]="'url(' + icon + ')'"></span>
          } @else {
            {{ num }}
          }
        </span>
        <span class="opt-section__heading">
          <tidy-text [title]="title" class="opt-section__title" />
          @if (description) {
            <tidy-text [helper]="description" class="opt-section__sub" />
          }
        </span>
        <span class="opt-section__chev" [class.opt-section__chev--open]="open">
          <tidy-image [src]="'assets/svg/chevron-down.svg'" />
        </span>
      </button>
      @if (open) {
        <div class="opt-section__body">
          <ng-content />
        </div>
      }
    </article>
  `,
  styleUrls: ['./optimization-section.component.scss'],
})
export class OptimizationSectionComponent {
  @Input() num = 1;
  // Path to an SVG mask; renders as a green-tinted icon inside the badge.
  // When supplied, replaces the numeric badge content.
  @Input() icon: string | null = null;
  @Input() title = '';
  @Input() description = '';
  @Input() open = false;
  @Input() connector = true;
  // When the body needs to host an edge-to-edge surface (e.g. the Price
  // Optimization card hosts the calendar full-bleed), strip the default
  // body padding so the projected content can supply its own.
  @Input() noPadding = false;
  @Output() openChange = new EventEmitter<boolean>();

  toggle(): void {
    this.open = !this.open;
    this.openChange.emit(this.open);
  }
}
